module.exports = __webpack_public_path__ + "static/media/Decisions_Step4_Image7c.ef76d07f.jpg";